export default __webpack_public_path__ + "static/media/finance-topic3.cd3d514c.png";